import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import FlaggedAdDetails from 'components/FlaggedAd/Details';

const ScreenFlaggedAdDetail = props => {
  const { classes, match } = props;
  return (
    <div className={classes.container}>
      <FlaggedAdDetails id={match.params.id} />
    </div>
  );
};

ScreenFlaggedAdDetail.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenFlaggedAdDetail);
